import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

export function getSubdivisionLabel(subdivisionType, country, t) {
  return t(subdivisionType === 'area' ? 'title.location' : country === 'US' ? 'title.zipCode' : 'title.postalCode');
}

export function SubdivisionTypeLabel({ subdivisionType, country }) {
  const { t } = useTranslation();
  return <>{getSubdivisionLabel(subdivisionType, country, t)}</>;
}

SubdivisionTypeLabel.propTypes = { subdivisionType: PropTypes.string, country: PropTypes.string };

export function getSubdivisionSettingLabel(subdivisionType, t) {
  return t(subdivisionType === 'area' ? 'title.useAreas' : 'title.useZipCodes');
}
